import AOS from "aos";
import { CountUp } from "countup.js";
class Animations {
    static initEvents() {
        var _a;
        if (this.isWebCrawler()) {
            Array.from((_a = document.querySelectorAll("[data-aos]")) !== null && _a !== void 0 ? _a : []).forEach((aosElement) => {
                if (!(aosElement instanceof HTMLElement)) {
                    return;
                }
                if (aosElement.dataset.aos) {
                    aosElement.dataset.noAos = aosElement.dataset.aos;
                    aosElement.dataset.aos = "false";
                }
            });
            return;
        }
        const aosParams = {
            disable: "mobile",
            duration: 1000,
            once: true,
        };
        AOS.init(aosParams);
        document.addEventListener("aos:in", this.onAosInCountUpEvent);
    }
    static isWebCrawler() {
        return (/bot|crawler|spider|crawling/i.test(navigator.userAgent)
            || window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    }
}
Animations.onAosInCountUpEvent = (e) => {
    // Cast Element as HTMLElement
    const el = e.detail;
    // Check is count-up event, or eventType is "aos:in:count-up"
    if (el.dataset.aosId === "count-up") {
        const stat = el.querySelector("[data-figure]");
        if (!stat || stat.dataset.figure === "")
            return;
        const options = {
            duration: 2.6,
            easingFn(t, b, c, d) {
                const ts = (t /= d) * t;
                const tc = ts * t;
                return b + c * (tc + -3 * ts + 3 * t);
            },
        };
        if (typeof stat.dataset.figure !== "undefined") {
            const number = stat.dataset.figure.replace(/[^\d\.\-]/g, "");
            options.decimalPlaces = (number.indexOf(".") === -1) ? 0 : number.split(".")[1].length;
            if (typeof stat.dataset.prefix !== "undefined") {
                options.prefix = stat.dataset.prefix;
            }
            if (typeof stat.dataset.suffix !== "undefined") {
                options.suffix = stat.dataset.suffix;
            }
            const demo = new CountUp(stat, parseFloat(number), options);
            if (!demo.error) {
                demo.start();
            }
            else {
                console.debug(demo.error);
            }
        }
        else {
            console.log("[Animations] countUp num undefined");
        }
    }
};
Animations.initEvents();
